import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import classnames from 'classnames';

import BrzwDatePicker from '../brzw_date_picker';

import './date_control.scss';

const DateControl = ({ activeDate, onChange, title, disabled }) => (
  <BrzwDatePicker
    className={classnames('date-control__date-picker', {
      'date-control__date-picker--disabled': disabled,
    })}
    customInput={
      <div className="date-control__date-picker-input">
        <span className="date-control__date-picker-value">{title}</span>
      </div>
    }
    disabled={disabled}
    onChange={onChange}
    selected={activeDate}
    withStyleguide
    popperModifiers={{
      preventOverflow: {
        enabled: true,
        escapeWithReference: false,
        boundariesElement: 'viewport',
      },
    }}
  />
);

DateControl.propTypes = {
  activeDate: PropTypes.shape({}),
  disabled: PropTypes.bool,
  onChange: PropTypes.func,
  title: PropTypes.string,
};

DateControl.defaultProps = {
  activeDate: moment(),
  disabled: false,
  onChange: () => {},
  title: '',
};

export default DateControl;
